const appLinkData = {
	iosApp: swaddle_app_links.appleStoreAppURL,
	androidApp: swaddle_app_links.googlePlayAppURL,
	overallFallback: swaddle_app_links.overallFallbackURL,
};

const redirectToAppropriatePlatform = (type) => {
	const userAgent = navigator.userAgent;
	const hasIos = appLinkData.iosApp ? true : false;
	const hasAndroid = appLinkData.androidApp ? true : false;
	const hasOverallFallback = appLinkData.overallFallback ? true : false;

	if (hasIos && /iP(hone|ad|od)/.test(userAgent)) {
		// Redirect to iOS app store URL
		window.location.href = appLinkData.iosApp;
	} else if (
		hasAndroid &&
		(/Android/.test(userAgent) ||
			userAgent.toLowerCase().indexOf('android') > -1)
	) {
		// Redirect to Google Play app store URL
		window.location.href = appLinkData.androidApp;
	} else if (hasOverallFallback) {
		if (type === '404') {
			return;
		}
		window.location = appLinkData.overallFallback;
	} else {
		console.log('Unknown platform and no overallFallback URL, nothing to do');
	}
};

if (document.querySelectorAll('a[href="#download-app"]')) {
	const downloadAppLinks = document.querySelectorAll('a[href="#download-app"]');

	downloadAppLinks.forEach(function (link) {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			redirectToAppropriatePlatform();
		});
	});
}

if (document.body.classList.contains('error404')) {
	redirectToAppropriatePlatform('404');
}
